import { Action, createReducer, on } from '@ngrx/store';
import { ManureFilters } from 'src/app/shared/models/manure-filters.model';

import { OverviewState, Tabs } from '../../models/overview.model';
import * as OverviewActions from '../actions/overview.actions';

export const initialState: OverviewState = {
  offerOverviewList: [],
  selectionButton: 'offers',
  totalNumberOfOffers: 0,
  totalNumberOfRequests: 0,
  status: 'pending',
  offerPageAndSize: {
    pageIndex: 0,
    pageSize: 25,
  },
  requestsPageAndSize: {
    pageIndex: 0,
    pageSize: 25,
  },
  currentTab: Tabs.manureOffers,
  filters: {} as ManureFilters,
  overviewOffersLoading: false,
  overviewRequestsLoading: false,
};

export const overviewReducer = createReducer(
  initialState,
  on(OverviewActions.loadOffers, (state, { paginationOptions }) => ({
    ...state,
    status: 'loading' as const,
    offerPageAndSize: paginationOptions,
  })),
  on(OverviewActions.loadOffersSuccess, (state, { offersList, totalNumberOfOffers }) => ({
    ...state,
    offerOverviewList: [...offersList],
    totalNumberOfOffers,
    status: 'success' as const,
  })),
  on(OverviewActions.switchToManureOffersOverview, (state) => ({
    ...state,
    currentTab: Tabs.manureOffers,
  })),
  on(OverviewActions.switchToManureRequestsOverview, (state) => ({
    ...state,
    currentTab: Tabs.manureRequests,
  })),
  on(OverviewActions.setFilters, (state, { filters }) => ({
    ...state,
    filters,
  })),
  on(OverviewActions.setOverviewOffersLoading, (state, { loading }) => ({
    ...state,
    overviewOffersLoading: loading,
  })),
  on(OverviewActions.setOverviewRequestLoading, (state, { loading }) => ({
    ...state,
    overviewRequestsLoading: loading,
  })),
  on(OverviewActions.clearFilters, (state) => ({
    ...state,
    filters: {} as ManureFilters,
  })),
  on(OverviewActions.loadRequests, (state, { paginationOptions }) => ({
    ...state,
    status: 'loading' as const,
    requestsPageAndSize: paginationOptions,
  })),
  on(OverviewActions.loadRequestsSuccess, (state, { requestsList, totalNumberOfRequests }) => ({
    ...state,
    requestsOverviewList: [...requestsList],
    totalNumberOfRequests,
    status: 'success' as const,
  })),
  on(OverviewActions.selectOffer, (state, { selectedOffer }) => ({
    ...state,
    selectedOffer,
  })),
  on(OverviewActions.selectRequest, (state, { selectedRequest }) => ({
    ...state,
    selectedRequest,
  })),
);

export const overviewStateReducer = (state: OverviewState | undefined, action: Action) =>
  overviewReducer(state, action);
